import { Field, Formik } from "formik";
import { observer } from "mobx-react-lite";
import * as Yup from "yup";

import styles from "../License.module.css";
import { Link } from "react-router-dom";

const LicenseFormFields = ({ onSubmit, initialValues, editMode = false }) => {
  const insuranceTypes = [
    "Liability",
    "Vehicle",
    "City",
    "County",
    "State",
    "Property",
    "Sunbiz",
    "Not Applicable",
  ];

  const validationSchema = Yup.object({
    license_description: Yup.string().required(
      "License description is required"
    ),
    insurance_type: Yup.string().oneOf(
      insuranceTypes,
      "Invalid insurance type"
    ),
    exp_date: Yup.date().required("Expiration date is required"),
  });

  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, isValid, dirty, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit}>
            <div className={styles.formField}>
              <div>
                <label className={styles.label}>License Description</label>
                <Field
                  name="license_description"
                  type="text"
                  placeholder="Enter License Description"
                  className={styles.inputField}
                />
              </div>
              <div>
                <label className={styles.label}>Insurance Type</label>
                <Field
                  name="insurance_type"
                  type={undefined}
                  as="select"
                  className={styles.inputField}
                >
                  <option value="">Select Insurance Type</option>
                  {insuranceTypes.map((type, i) => (
                    <option key={i} value={type}>
                      {type}
                    </option>
                  ))}
                </Field>
              </div>
              <div>
                <label className={styles.label}>Policy Number</label>
                <Field
                  name="policy_number"
                  type="text"
                  placeholder="Enter Policy Number"
                  className={styles.inputField}
                />
              </div>
              <div>
                <label className={styles.label}>Account Number</label>
                <Field
                  name="account_number"
                  type="text"
                  placeholder="Enter Account Number"
                  className={styles.inputField}
                />
              </div>
              <div>
                <label className={styles.label}>Expiration Date</label>
                <Field
                  name="exp_date"
                  type="date"
                  className={styles.inputField}
                />
              </div>
              <div>
                <label className={styles.label}>Cost</label>
                <Field
                  name="cost"
                  type="number"
                  placeholder="Enter Cost"
                  className={styles.inputField}
                />
              </div>
              <div>
                <label className={styles.label}>Paid</label>
                <div className={styles.checkboxInput}>
                  <Field name="paid" type="checkbox" />
                  <span>Mark as paid</span>
                </div>
              </div>
              <div>
                <label className={styles.label}>Operational Description</label>
                <Field
                  name="descript_ops"
                  as="textarea"
                  placeholder="Enter Operational Description"
                  className={styles.inputTextArea}
                />
              </div>
              <div>
                <label className={styles.label}>Certificate Holder</label>
                <Field
                  name="certificate_holder"
                  as="textarea"
                  placeholder="Enter Certificate Holder"
                  className={styles.inputTextArea}
                />
              </div>
              <div className={styles.uploadInput}>
                <label className={styles.label}>File Upload</label>
                <div>
                  <input
                    name="filename"
                    type="file"
                    onChange={(event) => {
                      const file = event.target.files[0];
                      setFieldValue("filename", file);
                    }}
                  />
                  {editMode && initialValues?.filename && (
                    <Link target={"_blank"} to={initialValues?.filename}>
                      View File
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <button
              className={`${styles.blueBtn} ${styles.licenseFormActions}`}
              type="submit"
              disabled={!isValid || !dirty}
            >
              Submit
            </button>
          </form>
        );
      }}
    </Formik>
  );
};

export default observer(LicenseFormFields);
